import type { ReactNode } from 'react';

import { Card, CardContent, CardHeader, CardTitle } from './card';
import { cn } from './lib/utils';

/**
 * Permissions v1: the one "No access" state every app shows when a user has
 * nothing they may see on the current page. Presentational only — callers
 * pass translated copy (the shared strings live in `@artic/i18n` common under
 * `navigation.noAccess.*`) and own any toast or redirect around it.
 */
export function NoAccessState({
  title,
  body,
  action,
  className,
}: {
  title: ReactNode;
  body: ReactNode;
  /** Optional follow-up, e.g. a link back to another app. */
  action?: ReactNode;
  /** Classes for the centring wrapper (defaults fill the parent's height). */
  className?: string;
}) {
  return (
    <div
      data-testid="no-access-state"
      className={cn('flex h-full w-full items-center justify-center p-4', className)}
    >
      <Card className="max-w-md">
        <CardHeader>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col gap-4">
          <p className="text-muted-foreground text-sm">{body}</p>
          {action}
        </CardContent>
      </Card>
    </div>
  );
}
